var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneNumberRelations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5281,
    cy: 23.775,
    r: 21.8327,
    fill: "white",
    stroke: "#0C9CB2",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8492_10595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2127 15.5164H21.0992L23.0424 20.3744L20.6134 21.8318C21.6539 23.9417 23.3615 25.6493 25.4714 26.6899L26.9288 24.2608L31.7868 26.2041V30.0905C31.7868 30.6059 31.5821 31.1001 31.2177 31.4645C30.8533 31.829 30.359 32.0337 29.8436 32.0337C26.0536 31.8034 22.479 30.194 19.7941 27.5091C17.1093 24.8242 15.4999 21.2496 15.2695 17.4596C15.2695 16.9442 15.4743 16.45 15.8387 16.0855C16.2031 15.7211 16.6974 15.5164 17.2127 15.5164Z",
    stroke: "#0C9CB2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8492_10595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3185,
    height: 23.3185,
    fill: "white",
    transform: "translate(12.3545 11.63)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumberRelations);
export default __webpack_public_path__ + "static/media/phone-number-relations.a2262daee59c981164285fafbda60539.svg";
export { ForwardRef as ReactComponent };